import { mybets } from "../../js/api/myBets.js";
import { cashout } from "../../js/api/betting.js";
import { mybet } from "../../js/api/myBet.js";
import { cancelBet } from "../../js/api/cancelbet.js";
import { generateView } from "../templates/mybets.js";
import { _t } from "../../services/TranslationService.js";
import Timeline from "../components/Timeline.js";

const runCashoutButtonCheck = async () => {
    $("#tblMyBets .singleBetTable").each(function (i, item) {
        let itemId = $(this).children(".singleBetHeader").attr("bet-id");
        let canCash = $(this).children(".singleBetHeader").attr("bet-can-cash");
        // alert(itemId);
        if ($(item).attr("cash-out-status") === "true" && (canCash !== '0')) {
            $(item).append(`<div class="cashoutHolderBtn"><a class="cashoutBtn" data-betId="${itemId}"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 64 80" style="enable-background:new 0 0 64 64;" xml:space="preserve"><rect x="13" y="59" width="22" height="2"/><path d="M43,40c0,0.5-0.5,1-1,1s-1,0.5-1,1s-0.5,1-1,1h-5v2h9c0.5,0,1-0.5,1-1V7h-2V40z"/><path d="M13.8,32.2c-0.5,1.3-0.7,2.6-0.4,3.9L17,53.9c0,0,0,0,0,0V57h14v-3.2l1.3-3.9c0.5-1.5,0.8-3,0.8-4.4V31.1  c0-1.1-0.9-2.2-2.1-2.1c-1.1,0-1.9,0.9-1.9,2l0,6.2c0,0.8-0.5,1.9-1.3,2.3C27,40,26.1,40,25.3,39.6l-7.9-4.7  C17.2,34.7,17,34.4,17,34v-9.2L13.8,32.2z M17.6,43c0.5-0.1,1.1,0.2,1.2,0.8l1.8,8c0.1,0.5-0.2,1.1-0.8,1.2c-0.1,0-0.9,0.3-1.2-0.8  l-1.8-8C16.7,43.7,17,43.2,17.6,43z"/><path d="M39.2,41c0.3-0.8,1-1.5,1.8-1.8V7H23v28.8l3.3,2c0.2,0.1,0.7,0.1,0.7-0.4V31c0-2.2,1.8-4,4-4s4,1.8,4,4v10H39.2z M39,36  c0,0.5-0.5,1-1,1s-1-0.5-1-1V26c0-0.5,0.5-1,1-1s1,0.5,1,1V36z M34,19c-0.5,0-1-0.5-1-1s0.5-1,1-1s1-0.5,1-1s-0.5-1-1-1s-1,0.5-1,1  c0,1.7-1.3,3-3,3c-1.3,0-2.4-0.8-2.8-2H26c-0.5,0-1-0.5-1-1s0.5-1,1-1h1.2c0.4-1.2,1.5-2,2.8-2c0.5,0,1,0.5,1,1s-0.5,1-1,1  s-1,0.5-1,1s0.5,1,1,1s1-0.5,1-1c0-1.7,1.3-3,3-3c1.3,0,2.4,0.8,2.8,2H38c0.5,0,1,0.5,1,1s-0.5,1-1,1h-1.2C36.4,18.2,35.3,19,34,19z  "/><polygon points="19,7 19,33.4 21,34.6 21,7 "/><path d="M60.1,3H3.9C3.3,3,3,3.3,3,3.9v4.2C3,8.7,3.3,9,3.9,9H17V7h-3c-0.5,0-1-0.5-1-1s0.5-1,1-1h36c0.5,0,1,0.5,1,1s-0.5,1-1,1h-3  v2h13.1C60.7,9,61,8.5,61,8.1V3.9C61,3.3,60.5,3,60.1,3z M8,7H6C5.5,7,5,6.5,5,6s0.5-1,1-1h2c0.5,0,1,0.5,1,1S8.5,7,8,7z M58,7h-2  c-0.5,0-1-0.5-1-1s0.5-1,1-1h2c0.5,0,1,0.5,1,1S58.5,7,58,7z"/><path d="M55,19.6V14c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0-0.8-1.1-1.7-0.3c-0.4,0.4-0.4,1,0,1.4l2,2c0,0,0.7,0.5,1.4,0l2-2  c0.4-0.4,0.4-1,0-1.4C55.9,18.5,55,19.6,55,19.6z"/><path d="M12.7,19.3c-0.9-0.8-1.7,0.3-1.7,0.3V14c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0-0.9-1.2-1.7-0.3c-0.4,0.4-0.4,1,0,1.4l2,2  c0,0,0.7,0.4,1.4,0l2-2C13.1,20.3,13.1,19.7,12.7,19.3z"/></svg><span>Cash out</span><span id="${itemId}-cash-out-value" style="padding-left:0;"></span></a></div>`);
        }
    });
}

const addCashoutButton = async (bet_id, bet) => {
    if (!bet_id || !bet) return;

    const can_cashout = bet.can_cashout == '1';
    const cash_out = bet.cash_out;
    const cash_out_value = parseFloat(bet.cash_out_value);

    const $element = $('#tblMyBets .singleBetTable:has(.singleBetHeader[bet-id=' + bet_id + '])');
    $($element).remove('.cashoutHolderBtn');
    if (can_cashout && cash_out_value > 0) {
        $($element).append(`
            <div class="cashoutHolderBtn">
                <a class="cashoutBtn" data-betId="${bet_id}">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 64 80" style="enable-background:new 0 0 64 64;" xml:space="preserve"><rect x="13" y="59" width="22" height="2"/><path d="M43,40c0,0.5-0.5,1-1,1s-1,0.5-1,1s-0.5,1-1,1h-5v2h9c0.5,0,1-0.5,1-1V7h-2V40z"/><path d="M13.8,32.2c-0.5,1.3-0.7,2.6-0.4,3.9L17,53.9c0,0,0,0,0,0V57h14v-3.2l1.3-3.9c0.5-1.5,0.8-3,0.8-4.4V31.1  c0-1.1-0.9-2.2-2.1-2.1c-1.1,0-1.9,0.9-1.9,2l0,6.2c0,0.8-0.5,1.9-1.3,2.3C27,40,26.1,40,25.3,39.6l-7.9-4.7  C17.2,34.7,17,34.4,17,34v-9.2L13.8,32.2z M17.6,43c0.5-0.1,1.1,0.2,1.2,0.8l1.8,8c0.1,0.5-0.2,1.1-0.8,1.2c-0.1,0-0.9,0.3-1.2-0.8  l-1.8-8C16.7,43.7,17,43.2,17.6,43z"/><path d="M39.2,41c0.3-0.8,1-1.5,1.8-1.8V7H23v28.8l3.3,2c0.2,0.1,0.7,0.1,0.7-0.4V31c0-2.2,1.8-4,4-4s4,1.8,4,4v10H39.2z M39,36  c0,0.5-0.5,1-1,1s-1-0.5-1-1V26c0-0.5,0.5-1,1-1s1,0.5,1,1V36z M34,19c-0.5,0-1-0.5-1-1s0.5-1,1-1s1-0.5,1-1s-0.5-1-1-1s-1,0.5-1,1  c0,1.7-1.3,3-3,3c-1.3,0-2.4-0.8-2.8-2H26c-0.5,0-1-0.5-1-1s0.5-1,1-1h1.2c0.4-1.2,1.5-2,2.8-2c0.5,0,1,0.5,1,1s-0.5,1-1,1  s-1,0.5-1,1s0.5,1,1,1s1-0.5,1-1c0-1.7,1.3-3,3-3c1.3,0,2.4,0.8,2.8,2H38c0.5,0,1,0.5,1,1s-0.5,1-1,1h-1.2C36.4,18.2,35.3,19,34,19z  "/><polygon points="19,7 19,33.4 21,34.6 21,7 "/><path d="M60.1,3H3.9C3.3,3,3,3.3,3,3.9v4.2C3,8.7,3.3,9,3.9,9H17V7h-3c-0.5,0-1-0.5-1-1s0.5-1,1-1h36c0.5,0,1,0.5,1,1s-0.5,1-1,1h-3  v2h13.1C60.7,9,61,8.5,61,8.1V3.9C61,3.3,60.5,3,60.1,3z M8,7H6C5.5,7,5,6.5,5,6s0.5-1,1-1h2c0.5,0,1,0.5,1,1S8.5,7,8,7z M58,7h-2  c-0.5,0-1-0.5-1-1s0.5-1,1-1h2c0.5,0,1,0.5,1,1S58.5,7,58,7z"/><path d="M55,19.6V14c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0-0.8-1.1-1.7-0.3c-0.4,0.4-0.4,1,0,1.4l2,2c0,0,0.7,0.5,1.4,0l2-2  c0.4-0.4,0.4-1,0-1.4C55.9,18.5,55,19.6,55,19.6z"/><path d="M12.7,19.3c-0.9-0.8-1.7,0.3-1.7,0.3V14c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0-0.9-1.2-1.7-0.3c-0.4,0.4-0.4,1,0,1.4l2,2  c0,0,0.7,0.4,1.4,0l2-2C13.1,20.3,13.1,19.7,12.7,19.3z"/></svg>
                    <span>Cash out</span>
                    <span id="${bet_id}-cash-out-value" style="padding-left:0;"></span>
                </a>
            </div>
        `);
    }
}

let myBetsInterval = null;
let MyBets = {
    render: async () => {
        // alert('asdasdasd');

        runCashoutButtonCheck();

        let view = /*html*/ `
<div class="cancelBtnMessageModal">
        <p>${_t('Basti ka kaluar kohen e anulimit')}</p>
    </div>
    <div class="myBetsWrapper">
             <div class="myBetsHeader">
               <a class="backBtn">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"/></svg>
               </a>
               <span>${_t('Bastet e mia')}</span>
             </div>
             <div class="newMyBetsFilter">
               <input type="text" readonly  class="form-control" id="myCalendar">
               <button type="button" class="btn-filter">${_t('Filtro')}</button>
             </div>
             <div class="my-bets-tabs" id="predefinedRanges">
             </div>
             <div class="filterMyBetsAdmin">
                <a class="active" data-param-id="0"> ${_t('Te gjitha')} </a>
                <a class="" data-param-id=4> ${_t('Fituese')} </a>
                <a class="" data-param-id="5"> ${_t('Humbese')} </a>
                <a class="" data-param-id="2"> ${_t('Ne pritje')} </a>
                <a class="" data-param-id="6"> ${_t('Te anuluara')} </a>
             </div>
             <div class="myBetsTable" id="tblMyBets">

             </div>
             <div id="myBetsFooter" class="myBetsFooter">
               <span>${_t('All')}</span>

             </div>
           </div>
     `;
        return view;
    },
    after_render: async () => {
        let today = new Date();
        let todaySet = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getFullYear();

        today = yyyy + "-" + mm + "-" + dd;
        let startDate = today;
        let endDate = today;

        const currency = JSON.parse(localStorage.getItem("coins"));

        let mybetsprofile = await mybets(startDate, endDate, currency[0].id);
        let myBetsView = await generateView(mybetsprofile);
        $("body #tblMyBets").append(myBetsView);

        let isexecuted = 0;

        let allCurrencies = [];

        mybetsprofile.forEach((element) => {
            let totalBet1 = parseFloat(element.stake);
            let winTotal = 0;
            if (element.name == "Won" && element.possible_win)
                winTotal = parseFloat(element.possible_win);
            const elementCurrency = allCurrencies.find(
                (a) => a.currency == element.currency_id
            );
            if (elementCurrency) {
                elementCurrency.totalBet1 += totalBet1;
                elementCurrency.winTotal += winTotal;
            } else {
                allCurrencies.push({
                    currency: element.currency_id,
                    totalBet1: totalBet1,
                    winTotal: winTotal,
                    currency_name: element.currency_name,
                });
            }
        });

        let months = [
            _t("Janar"),
            _t("Shkurt"),
            _t("Mars"),
            _t("Prill"),
            _t("Maj"),
            _t("Qershor"),
            _t("Korrik"),
            _t("Gusht"),
            _t("Shtator"),
            _t("Tetor"),
            _t("Nentor"),
            _t("Dhjetor"),
        ];
        console.log('months', months);
        let currentMonthDescription = `${months[todaySet.getMonth()]}`;

        let ranges = {};
        ranges[_t('Sot')] = [moment(), moment()];
        ranges[_t('Dje')] = [moment().subtract(1, "days"), moment().subtract(1, "days")];
        ranges = {
            ...ranges,
            2023: [moment().startOf('year'), moment().endOf('year')],
            2022: [moment().subtract(1, "year").startOf('year'), moment().subtract(1, 'year').endOf('year')],
        };

        ranges[`${currentMonthDescription}`] = [
            moment().startOf("month"),
            moment().endOf("month"),
        ];
        ranges[
            `${months[todaySet.getMonth() == 0 ? 11 : todaySet.getMonth() - 1]}`
        ] = [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
            ];

        if (allCurrencies) {
            allCurrencies.forEach(element => {
                $("body #myBetsFooter").append(`<div style="    width: 100%;
        float: left;"><span>${element.currency_name}</span><span>${(element.totalBet1 - element.winTotal).toFixed(2)}</span></div>`);

                // $("body #totalBetsValue").text((totalBet1 - winTotal).toFixed(2));
                // $("body #totalBetsCurrency").text((totalBet1 - winTotal).toFixed(2));
            });

        }


        /*
                           <span id="totalBetsCurrency"></span>
                   
            */
        async function dateRangePickerCallback(start, end, status) {
            $('#predefinedRanges .my-bets-tabs__item.active').removeClass('active');
            $("#contentLoader").append('<div class="loaderWrapper"><div class="loader"></div></div>"');
            let startDate = start.format("YYYY-MM-DD");
            let endDate = end.format("YYYY-MM-DD");

            // betsStartDate = startDate;
            // betsEndDate = endDate;
            const currency = JSON.parse(localStorage.getItem("coins"));
            const myBets = await mybets(startDate, endDate, currency[0].id, status);

            let allCurrencies = [];

            let littleView = await generateView(myBets);

            $("body #tblMyBets *").remove();
            $("body #tblMyBets").append(littleView);

            runCashoutButtonCheck();

            myBets.forEach((element) => {
                let totalBet1 = parseFloat(element.stake);
                let winTotal = 0;
                if (element.name == "Won" && element.possible_win)
                    winTotal = parseFloat(element.possible_win);
                const elementCurrency = allCurrencies.find(
                    (a) => a.currency == element.currency_id
                );
                if (elementCurrency) {
                    elementCurrency.totalBet1 += totalBet1;
                    elementCurrency.winTotal += winTotal;
                } else {
                    allCurrencies.push({
                        currency: element.currency_id,
                        totalBet1: totalBet1,
                        winTotal: winTotal,
                        currency_name: element.currency_name,
                    });
                }
            });




            $('body #myBetsFooter').html(`<span>${_t('All')}</span>`);
            allCurrencies.forEach(element => {
                $("body #myBetsFooter").append(`<div style="    width: 100%;
        float: left;"><span>${element.currency_name}</span><span>${(element.totalBet1 - element.winTotal).toFixed(2)}</span></div>`);

                // $("body #totalBetsValue").text((totalBet1 - winTotal).toFixed(2));
                // $("body #totalBetsCurrency").text((totalBet1 - winTotal).toFixed(2));
            });
            $("body .loaderWrapper").remove();
        }

        $("#myCalendar").daterangepicker({
            // ranges: ranges,
            alwaysShowCalendars: false,
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day"),
            opens: "center",
            linkedCalendars: false, // This prevents showing two months
            showCustomRangeLabel: false, 
            opens: "center",
            locale: {
                direction: "ltr",
                format: "DD/MM/YYYY",
                separator: " - ",
                applyLabel: _t('Apliko'),
                cancelLabel: "Anulo",
                fromLabel: "Da",
                toLabel: "A",
                customRangeLabel: "Personalizzata",
                daysOfWeek: ["DI", "HA", "MA", "ME", "EN", "PR", "SH"],
                monthNames: months,
                firstDay: 1,
            },
        },
            dateRangePickerCallback
        );

        const todayKey = _t('Sot');
        Object.keys(ranges).forEach(key => {
            $('#predefinedRanges').append(`<div class="my-bets-tabs__item ${key === todayKey ? 'active' : ''}" data-value="${key}">${key}</div>`)
        });

        $("body").on("click", "#predefinedRanges .my-bets-tabs__item", async function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            // if ($(this).hasClass('active')) {
            //   return;
            // }
            const key = $(this).attr('data-value');
            if (ranges[key] !== undefined) {
                const range = ranges[key];
                console.log('Range', range);
                if (range && range.length === 2) {
                    $('#myCalendar').data('daterangepicker').setStartDate(range[0]);
                    $('#myCalendar').data('daterangepicker').setEndDate(range[1]);
                    dateRangePickerCallback(range[0], range[1], null);
                }
            }

            $('#predefinedRanges .my-bets-tabs__item.active').removeClass('active');
            $(this).addClass('active');
        });

        $('body').on('click', '.filterMyBetsAdmin a', async function (e) {
            $(e.currentTarget).parent().children('a').removeClass('active');
            $(e.currentTarget).addClass('active');
            const bet_status = $(e.currentTarget).attr('data-param-id');
            const start = $('#myCalendar').data('daterangepicker').startDate;
            const end = $('#myCalendar').data('daterangepicker').endDate;
            dateRangePickerCallback(start, end, bet_status);
        });

        runCashoutButtonCheck();

        $("body").on("click", ".singleBetHeader", async function (e) {
            if (isexecuted) return;
            isexecuted = 1;
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            if ($(e.currentTarget).parent().hasClass("showDetail")) {
                $(e.currentTarget).parent().removeClass("showDetail");
                $(e.currentTarget)
                    .siblings(".singleBetContent")
                    .children(".singleBetItem")
                    .remove();
                $(e.currentTarget).parents('.singleBetTable').find('.cashoutHolderBtn').remove();
                $(e.currentTarget).parents('.singleBetTable').find('.cashedOutHolder').remove();
            } else {
                let winCashStatus = 0;

                let itemId = $(this).attr("bet-id");
                var getmyBets = await mybet($(this).attr("bet-id"));
                // if (getmyBets.length < 3) {
                //     $(e.currentTarget).parent().attr("cash-out-status", "false");
                //     $(e.currentTarget).siblings(".cashoutHolderBtn").remove();
                // }

                if (
                    $(e.currentTarget).parent(".singleBetTable").attr("cashingout") ===
                    "true"
                ) {
                    $(e.currentTarget)
                        .parent()
                        .append(
                            `<div class="cashedOutHolder"><span>${_t('Cashed Out')}</span><svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 100 100"><g transform="translate(0,-952.36218)"><path style="color:#000000;enable-background:accumulate;" d="m 43,963.36219 -30,10 0,37.62501 c 0,13.46 15.9375,20.8512 30,30.375 6.452529,-4.3699 13.28977,-8.2973 18.8125,-12.5625 C 58.84116,1025.892 57,1021.8314 57,1017.3622 c 0,-8.8129 7.187129,-16 16,-16 l 0,-28.00001 -30,-10 z m 30,40.00001 c -7.73199,0 -14,6.268 -14,14 0,7.732 6.26801,14 14,14 7.731979,0 14,-6.268 14,-14 0,-7.732 -6.268021,-14 -14,-14 z m 0,5 c 1.1046,0 2,0.8954 2,2 l 0,5 5,0 c 1.104569,0 2,0.8954 2,2 0,1.1046 -0.895431,2 -2,2 l -5,0 0,5 c 0,1.1046 -0.8954,2 -2,2 -1.104601,0 -2,-0.8954 -2,-2 l 0,-5 -5,0 c -1.10457,0 -2,-0.8954 -2,-2 0,-1.1046 0.89543,-2 2,-2 l 5,0 0,-5 c 0,-1.1046 0.895399,-2 2,-2 z" fill="#000000" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"/></g></svg></div>`
                        );
                    $('.singleBetBonus[bet-id="' + itemId + '"]').hide();
                } else {
                    $(e.currentTarget).parent().children(".cashedOutHolder").remove();
                }

                if (getmyBets.some(bet => bet.can_cashout === '1' && parseFloat(bet.cash_out_value) > 0)) {
                    // $(e.currentTarget).parent().attr("cash-out-status", "true");
                    addCashoutButton($(this).attr("bet-id"), getmyBets[0]);
                }

                getmyBets.forEach((getmyBet) => {
                    if (getmyBet.bet_detail_status == "Won") {
                        winCashStatus++;
                    }

                    let cashingOut = "";
                    let cashingOutLabel = "";
                    let statusBet = "";
                    let typeLabel = "";
                    let typeClass = "";

                    if (winCashStatus < 2) {
                        $("body .cashoutBtn").addClass("disabledEvent");
                    } else {
                        $("body .cashoutBtn").removeClass("disabledEvent");
                    }

                    let date = new Date();

                    let yeFormated = date.getFullYear();
                    let moFormated = ("0" + (date.getMonth() + 1)).slice(-2);
                    let daFormated = date.getDate();
                    let hhFormated = date.getHours();
                    let mmFormated = date.getMinutes();
                    let ssFormated = ("0" + (date.getSeconds() + 1)).slice(-2);

                    let fullDateFormated =
                        yeFormated +
                        "-" +
                        moFormated +
                        "-" +
                        daFormated +
                        " " +
                        hhFormated +
                        ":" +
                        mmFormated +
                        ":" +
                        ssFormated;

                    function parseDate(date) {
                        const parsed = Date.parse(date);
                        if (!isNaN(parsed)) {
                            return parsed;
                        }

                        return Date.parse(date.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                    }

                    let nowIsPast =
                        parseDate(getmyBet.game_date) > parseDate(fullDateFormated);



                    if (getmyBet.bet_detail_status === "Lost") {
                        statusBet = "lostBetItem";
                    }
                    if (getmyBet.bet_detail_status === "Won") {
                        statusBet = "wonBetItem";
                    }
                    if (getmyBet.bet_detail_status === "Approved") {
                        statusBet = "approvedBetItem";
                    }
                    if (getmyBet.bet_detail_status === "Canceled") {
                        statusBet = "canceledBetItem";
                    }

                    $(`#${$(this).attr("bet-id")}-cash-out-value`).text(
                        `(${parseFloat(getmyBet.cash_out_value).toFixed(2)})`
                    );

                    if (getmyBet.type_id == 2) {
                        let game_minute = "", game_result = "";
                        if (['2', '4', '255'].includes(getmyBet.game_status)) {
                            game_minute = getmyBet.game_status == '2' ? 'HT' : 'FT';
                        } else {
                            game_minute = '' + getmyBet.game_minute.split(":")[0];
                        }
                        game_result = " - (" + getmyBet.game_result.replace("-", ":") + ") ";
                        typeLabel = `<b>Live - <time>${game_minute}</time><result>${game_result}</result></b>`;
                        typeClass = " live "
                    }
                    // if (
                    //     getmyBet.type_id == 2 ||
                    //     (!nowIsPast && getmyBet.bet_detail_status != "Won")
                    // ) {
                    //     $(e.currentTarget).parent().attr("cash-out-status", "false");
                    //     $(e.currentTarget).siblings(".cashoutHolderBtn").remove();
                    // }
                    if (getmyBet.game_cash_out == 1) {
                        cashingOutLabel = "cashing ";
                        cashingOut = `<div class="defendedGame"><svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 100 100"><g transform="translate(0,-952.36218)"><path style="color:#000000;enable-background:accumulate;" d="m 43,963.36219 -30,10 0,37.62501 c 0,13.46 15.9375,20.8512 30,30.375 6.45253,-4.3699 13.28977,-8.2973 18.8125,-12.5625 C 58.84116,1025.892 57,1021.8314 57,1017.3622 c 0,-8.8129 7.18713,-16 16,-16 l 0,-28.00001 -30,-10 z m 30,40.00001 c -7.73199,0 -14,6.268 -14,14 0,7.732 6.26801,14 14,14 7.73198,0 14,-6.268 14,-14 0,-7.732 -6.26802,-14 -14,-14 z m 0,5 c 0.57711,0 1.07243,0.2653 1.4375,0.6562 1.66486,1.4838 3.30646,3.3365 4.96875,4.9376 0.80455,0.8045 0.78114,2.0316 0,2.8124 -0.78114,0.7812 -2.03138,0.7812 -2.8125,0 L 75,1015.1747 l 0,9.1875 c 0,1.1046 -0.8953,2 -2,2 -1.1047,0 -2,-0.8954 -2,-2 l 0,-9.1875 -1.59375,1.5937 c -0.78112,0.7812 -2.03136,0.7812 -2.8125,0 -0.78114,-0.7808 -0.79674,-2.0079 0,-2.8124 1.62691,-1.637 3.33311,-3.4237 4.96875,-4.9376 0.36508,-0.3909 0.86039,-0.6562 1.4375,-0.6562 z" fill="#000000" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"/></g></svg></div>`;
                    }
                    let minute_and_result = '';
                    if (getmyBet.current_minute && getmyBet.current_result) {
                      minute_and_result = `<i>${getmyBet.current_minute.split(":")[0]}' - ${getmyBet.current_result.replace("-", ":")}</i> - `;
                      if (!minute_and_result) minute_and_result = '';
                    }
                    $(e.currentTarget)
                        .siblings(".singleBetContent")
                        .append(
                            '<div class="singleBetItem cashoutHolder ' +
                            typeClass + 
                            cashingOutLabel +
                            statusBet +
                            `" game-id="${getmyBet.game_id}">\n` +
                            '                       <div class="singleBetItemIcon">\n' +
                            '                         <svg class="lostIcon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 12 12"><g fill-rule="nonzero" fill="none"><circle fill="#C46464" cx="6" cy="6" r="6"></circle><path fill="#000" d="M6.414 6L8.69 3.724l-.414-.414L6 5.586 3.724 3.31l-.414.414L5.586 6 3.352 8.276l.414.414L6 6.414 8.234 8.69l.414-.414z"></path></g></svg>\n' +
                            '                         <svg class="canceledIcon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 12 12"><g fill-rule="nonzero" fill="none"><circle fill="#01979e" cx="6" cy="6" r="6"></circle><path fill="#fff" d="M6.414 6L8.69 3.724l-.414-.414L6 5.586 3.724 3.31l-.414.414L5.586 6 3.352 8.276l.414.414L6 6.414 8.234 8.69l.414-.414z"></path></g></svg>\n' +
                            '                         <svg class="wonIcon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 12 12"><g fill-rule="nonzero" fill="none"><circle fill="#4ACFA5" cx="6" cy="6" r="6"></circle><path fill="#0B1C19" d="M2.4 6.207L5.172 9.02l4.8-4.8-.579-.621-4.22 4.18L3.02 5.627z"></path></g></svg>\n' +
                            '                         <svg class="approvedIcon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 12 12"><g fill-rule="nonzero" fill="none"><circle fill="#01979e" cx="6" cy="6" r="6"></circle><path fill="#fff" d="M2.4 6.207L5.172 9.02l4.8-4.8-.579-.621-4.22 4.18L3.02 5.627z"></path></g></svg>\n' +
                            "                       </div>\n" +
                            '                       <div class="singleBetItemDetails">\n' +
                            "                         <span>" +
                            typeLabel +
                            "<i>" +
                            getmyBet.game_date.split(" ")[0] +
                            " " +
                            getmyBet.game_date.split(" ")[1].split(":")[0] +
                            ":" +
                            getmyBet.game_date.split(" ")[1].split(":")[1] +
                            "</i>" +
                            getmyBet.home_team +
                            " - " +
                            getmyBet.away_team +
                            "</span>\n" +
                            "                         <span>" +
                            minute_and_result +
                            _t(getmyBet.market_name) +
                            " - " +
                            _t(getmyBet.market_option_name) +
                            "</span>\n" +
                            "                       </div>\n" +
                            '                       <span class="singleBetItemOdd"><span style="min-width: 20px; display: block;">' +
                            Math.floor(
                                (parseFloat(getmyBet.coeficient_value) + Number.EPSILON) * 100
                            ) /
                            100 +
                            `</span><span class="expander" game-api-id="${getmyBet.game_api_id}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg></span></span>\n` +
                            `<div class="timeline-wrapper" style="display: block; clear: both;"></div>\n` +
                            cashingOut +
                            "\n" +
                            "                     </div>"
                        );
                    
                    const $parent = $(e.currentTarget).parent();
                    const cashOutButton = parseFloat(getmyBet.cash_out_value) > 0.01 && getmyBet.can_cashout === '1';
                    $parent.attr("cash-out-status", cashOutButton);
                    $parent.find(".cashoutHolderBtn").remove();
                    if (cashOutButton) {
                        $parent.append(`<div class="cashoutHolderBtn"><a class="cashoutBtn" data-betId="${itemId}"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 64 80" style="enable-background:new 0 0 64 64;" xml:space="preserve"><rect x="13" y="59" width="22" height="2"/><path d="M43,40c0,0.5-0.5,1-1,1s-1,0.5-1,1s-0.5,1-1,1h-5v2h9c0.5,0,1-0.5,1-1V7h-2V40z"/><path d="M13.8,32.2c-0.5,1.3-0.7,2.6-0.4,3.9L17,53.9c0,0,0,0,0,0V57h14v-3.2l1.3-3.9c0.5-1.5,0.8-3,0.8-4.4V31.1  c0-1.1-0.9-2.2-2.1-2.1c-1.1,0-1.9,0.9-1.9,2l0,6.2c0,0.8-0.5,1.9-1.3,2.3C27,40,26.1,40,25.3,39.6l-7.9-4.7  C17.2,34.7,17,34.4,17,34v-9.2L13.8,32.2z M17.6,43c0.5-0.1,1.1,0.2,1.2,0.8l1.8,8c0.1,0.5-0.2,1.1-0.8,1.2c-0.1,0-0.9,0.3-1.2-0.8  l-1.8-8C16.7,43.7,17,43.2,17.6,43z"/><path d="M39.2,41c0.3-0.8,1-1.5,1.8-1.8V7H23v28.8l3.3,2c0.2,0.1,0.7,0.1,0.7-0.4V31c0-2.2,1.8-4,4-4s4,1.8,4,4v10H39.2z M39,36  c0,0.5-0.5,1-1,1s-1-0.5-1-1V26c0-0.5,0.5-1,1-1s1,0.5,1,1V36z M34,19c-0.5,0-1-0.5-1-1s0.5-1,1-1s1-0.5,1-1s-0.5-1-1-1s-1,0.5-1,1  c0,1.7-1.3,3-3,3c-1.3,0-2.4-0.8-2.8-2H26c-0.5,0-1-0.5-1-1s0.5-1,1-1h1.2c0.4-1.2,1.5-2,2.8-2c0.5,0,1,0.5,1,1s-0.5,1-1,1  s-1,0.5-1,1s0.5,1,1,1s1-0.5,1-1c0-1.7,1.3-3,3-3c1.3,0,2.4,0.8,2.8,2H38c0.5,0,1,0.5,1,1s-0.5,1-1,1h-1.2C36.4,18.2,35.3,19,34,19z  "/><polygon points="19,7 19,33.4 21,34.6 21,7 "/><path d="M60.1,3H3.9C3.3,3,3,3.3,3,3.9v4.2C3,8.7,3.3,9,3.9,9H17V7h-3c-0.5,0-1-0.5-1-1s0.5-1,1-1h36c0.5,0,1,0.5,1,1s-0.5,1-1,1h-3  v2h13.1C60.7,9,61,8.5,61,8.1V3.9C61,3.3,60.5,3,60.1,3z M8,7H6C5.5,7,5,6.5,5,6s0.5-1,1-1h2c0.5,0,1,0.5,1,1S8.5,7,8,7z M58,7h-2  c-0.5,0-1-0.5-1-1s0.5-1,1-1h2c0.5,0,1,0.5,1,1S58.5,7,58,7z"/><path d="M55,19.6V14c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0-0.8-1.1-1.7-0.3c-0.4,0.4-0.4,1,0,1.4l2,2c0,0,0.7,0.5,1.4,0l2-2  c0.4-0.4,0.4-1,0-1.4C55.9,18.5,55,19.6,55,19.6z"/><path d="M12.7,19.3c-0.9-0.8-1.7,0.3-1.7,0.3V14c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.6c0,0-0.9-1.2-1.7-0.3c-0.4,0.4-0.4,1,0,1.4l2,2  c0,0,0.7,0.4,1.4,0l2-2C13.1,20.3,13.1,19.7,12.7,19.3z"/></svg><span>Cash out (${parseFloat(getmyBet.cash_out_value).toFixed(2)})</span><span id="${itemId}-cash-out-value" style="padding-left:0;"></span></a></div>`);
                    }
                });
                // console.log($(this).attr('bet-id'));
                $(e.currentTarget).parent().addClass("showDetail");
            }
            isexecuted = 0;


            $(".singleBetItemOdd .expander").unbind('click');
            $(".singleBetItemOdd .expander").click(async function (e) {
                e.preventDefault();
                $(this).toggleClass('open');
                var $timelineWrapper = $(this).closest('.singleBetItem').find('.timeline-wrapper');
                if ($(this).hasClass('open')) {
                    var gameId = $(this).attr('game-api-id');
                    var timeline = await Timeline.render(gameId);
                    $timelineWrapper.html(timeline);
                    Timeline.refreshTimeline(gameId);
                } else {
                    $timelineWrapper.html('');
                }
            });
        });

        $("body").on("click", ".cancelBetBtn", async function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            if (confirm('A jeni i sigurt qe doni te anulloni bileten?') == true) {
                let betId = $(e.currentTarget)
                    .siblings(".singleBetHeader")
                    .attr("bet-id");
                await cancelBet(betId);
            }
        });

        $("body").on("click", ".cashoutBtn", async function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            let betId = $(e.currentTarget).attr("data-betid");
            const result = await cashout(betId);
            if (result.success) {
                alert(_t("Perfundoj cash-out me sukses"));
                $('.btn-filter').click();
            } else {
                alert(result.error);
            }
        });

        if (myBetsInterval == null) {
            myBetsInterval = setInterval(() => {
                $('.singleBetTable.showDetail>.singleBetHeader').each(async function (i, item) {
                    var getmyBets = await mybet($(this).attr("bet-id"));
                    if (getmyBets.length > 0) {
                        getmyBets.forEach((getmyBet) => {
                            const $item = $('.singleBetItem[game-id="' + getmyBet.game_id + '"]');
                            if (!$item.length) return;
                            let game_minute = "", game_result = "";
                            if (['2', '4', '255'].includes(getmyBet.game_status)) {
                                game_minute = getmyBet.game_status == '2' ? 'HT' : 'FT';
                            } else {
                                game_minute = '' + getmyBet.game_minute.split(":")[0];
                            }
                            game_result = " - (" + getmyBet.game_result.replace("-", ":") + ") ";
                            $($item).find('time').text(game_minute);
                            $($item).find('result').text(game_result);

                            const $parent = $item.parent(".singleBetTable.showDetail");
                            const cashOutButton = parseFloat(getmyBet.cash_out_value) > 0.01 && getmyBet.can_cashout === '1';
                            $parent.attr("cash-out-status", cashOutButton);
                            if (!cashOutButton) {
                                $parent.find(".cashoutHolderBtn").remove();
                            }
                        });
                    }
                });
            }, 20000);
        }
    },
    on_unload: () => {
        clearInterval(myBetsInterval);
        myBetsInterval = null;
    },
    hideFooterCasino: true
};

export default MyBets;
